export default "__VITE_ASSET__eb871d12__"